/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module NavigationModule
 */

import { Pipe, PipeTransform } from '@angular/core';
import { StateAccessService } from 'ng/modules/core/services';

/**
 * @description Pipe to convert a state name to its associated permission.
 * @author alextsg
 */
@Pipe({
    name: 'stateNameToPermission',
})
export class StateNameToPermissionPipe implements PipeTransform {
    constructor(private readonly stateAccessService: StateAccessService) {}

    public transform(stateName: string): string | undefined {
        return this.stateAccessService.getPermissionFromStateName(stateName);
    }
}
